import { useQuery } from '@tanstack/react-query';
import { brgsApi } from '../api/brgs';
import { EngagementSummaryDto } from '../types';

export function useEngagementSummary() {
  return useQuery<EngagementSummaryDto, Error>({
    queryKey: ['engagement-summary'],
    queryFn: () => brgsApi.getEngagementSummary(),
  });
}
